import * as React from "react";

const QuestionCircle: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M6.268 12.5a6 6 0 100-12 6 6 0 000 12zm-2.02-8.126A1.315 1.315 0 015.484 3.5H6.85a1.479 1.479 0 01.736 2.763l-.757.434a.564.564 0 01-1.125-.01v-.316c0-.201.108-.387.284-.487l1.038-.596a.354.354 0 00-.176-.66H5.485c-.08 0-.15.049-.176.124l-.01.028a.562.562 0 01-1.059-.375l.01-.028-.003-.003zm1.27 4.376a.75.75 0 111.5 0 .75.75 0 01-1.5 0z"
            />
        </svg>
    );
};

export default React.memo(QuestionCircle);
